module.exports = __webpack_public_path__ + "img/fr10.ff29dae0.png";